module.exports = __webpack_public_path__ + "static/media/middle_wave.51b6f653.svg";